import { operatorClient } from 'domain/HttpClients';

export const automaticFetch = (data) => operatorClient
  .Post('/api/vehicles/available')
  .withData(data)
  .send();

export const manualFetch = (data) => operatorClient
  .Post('/api/fleets/management/reassign')
  .withData(data)
  .send();

export const reassign = (data) => operatorClient
  .Post('/api/fleets/management/assignment')
  .withData(data)
  .send();

export const fetchDrivers = (data, headers) => operatorClient
  .Post('/api/vehicles/available')
  .withData(data)
  .send();
